const INSPECTOR_LABELS = {
  en: {
    fields: {
      alignItems: 'Align items',
      alignSelf: 'Align self',
      behaviorGraph: 'Graph',
      clip: 'Clip',
      componentName: 'Component name',
      fit: 'Fit',
      flexBasis: 'Flex basis',
      flexGrow: 'Flex grow',
      flexShrink: 'Flex shrink',
      gap: 'Gap',
      height: 'Height',
      instanceName: 'Instance name',
      layerName: 'Layer name',
      layout: 'Layout',
      name: 'Name',
      origin: 'Origin',
      padding: 'Padding',
      rotation: 'Rotation',
      position: 'Position',
      scale: 'Scale',
      sizeMode: 'Size mode',
      source: 'Source',
      visible: 'Visible',
      width: 'Width',
      justifyContent: 'Justify content',
    },
    sections: {
      behavior: 'Behavior',
      child: 'Child',
      data: 'Data',
      geometry: 'Geometry',
      layout: 'Layout',
      material: 'Material',
      size: 'Size',
      transform: 'Transform',
    },
    subsections: {
      alignment: 'Alignment',
    },
  },
} as const;

export type InspectorLocale = keyof typeof INSPECTOR_LABELS;
export type InspectorFieldId = keyof typeof INSPECTOR_LABELS.en.fields;
export type InspectorSectionId = keyof typeof INSPECTOR_LABELS.en.sections;
export type InspectorSubsectionId = keyof typeof INSPECTOR_LABELS.en.subsections;

let activeInspectorLocale: InspectorLocale = 'en';

export function setInspectorLocale(locale: InspectorLocale): void {
  activeInspectorLocale = locale;
}

export function getInspectorFieldLabel(id: InspectorFieldId): string {
  return INSPECTOR_LABELS[activeInspectorLocale].fields[id];
}

export function getInspectorSectionLabel(id: InspectorSectionId): string {
  return INSPECTOR_LABELS[activeInspectorLocale].sections[id];
}

export function getInspectorSubsectionLabel(id: InspectorSubsectionId): string {
  return INSPECTOR_LABELS[activeInspectorLocale].subsections[id];
}
